// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a3ec9948","239":"62c985e9","455":"64e83c52"}[chunkId] + ".chunk.js";
};